import { render } from "./icon-arrow-up.vue?vue&type=template&id=547f3526"
import script from "./icon-arrow-up.vue?vue&type=script&lang=js"
export * from "./icon-arrow-up.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__